"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServiceBayTypeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useServiceBayTypeStore = (0, pinia_1.defineStore)("serviceBayTypeStore", {
    state: () => ({
        serviceBayTypes: [],
    }),
    getters: {
        getAll(state) {
            return state.serviceBayTypes;
        },
    },
    actions: {
        async fetchServiceBayTypes() {
            this.serviceBayTypes = [];
            try {
                const response = await (0, fetch_1.default)("/api/service-bay-types/get", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
                if (response.error) {
                    throw new Error(i18n_1.default.trans("backend_service_bay_type_error", "No service bay type found!", "backend_service_bay_types"));
                }
                response.forEach((item) => {
                    //console.log(item);
                    this.serviceBayTypes.push(item);
                });
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
});
